import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: "Antes me pedían 'resúmelo' en cada reunión. Ahora entro con el modelo 3S y en 30 segundos ya tengo su atención. Las decisiones son más rápidas y mi equipo avanza sin dudas.",
  author: 'Miguel Ángel',
  role: 'Director Comercial',
  image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
  metric: 'Reuniones 50% más cortas'
}, {
  quote: 'El método PERLA cambió mis reuniones. Ya no divago. Entro, dirijo y cierro con acción concreta. Mi equipo lo nota y mi jefe ha empezado a delegarme proyectos más grandes.',
  author: 'Andrea Ruiz',
  role: 'Gerente de Proyectos',
  image: 'https://images.unsplash.com/photo-1573496359-136d47552640?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
  metric: 'Mayor autoridad'
}, {
  quote: 'Dejé de evitar conversaciones difíciles. DESC me dio la estructura que necesitaba para decir lo que pienso sin sonar agresivo. Ahora resuelvo conflictos sin drama.',
  author: 'Carlos Mendoza',
  role: 'Líder de Equipo',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80',
  metric: 'Conflictos resueltos'
}];
export function Testimonials() {
  return <section className="py-24 bg-[#F5F1E8]" data-id="element-456">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-457">
        <div className="text-center mb-16" data-id="element-458">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-[#1a3a52] mb-4" data-id="element-459">
            Resultados Reales
          </motion.h2>
          <div className="w-24 h-1 bg-[#C9A961] mx-auto rounded-full" data-id="element-460" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-461">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col h-full" data-id="element-462">
              <div className="flex gap-1 mb-6" data-id="element-463">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-[#C9A961] text-[#C9A961]" data-id="element-464" />)}
              </div>

              <p className="text-gray-600 italic mb-8 flex-grow leading-relaxed" data-id="element-465">
                "{item.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-gray-100" data-id="element-466">
                <img src={item.image} alt={item.author} className="w-12 h-12 rounded-full object-cover border-2 border-[#C9A961]" data-id="element-467" />
                <div data-id="element-468">
                  <h4 className="font-bold text-[#1a3a52]" data-id="element-469">{item.author}</h4>
                  <p className="text-xs text-gray-500" data-id="element-470">{item.role}</p>
                </div>
              </div>

              <div className="mt-4 bg-[#F5F1E8] text-[#1a3a52] text-xs font-bold py-1 px-3 rounded-full self-start" data-id="element-471">
                {item.metric}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}